import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    position: 'relative',
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8,
    marginTop: 28
  },
  priceTitleContainer: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    right: 0,
    top: -22
  },
  // Statement layout: one line per amount, label right, signed amount left.
  statement: {
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 8
  },
  line: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 3
  },
  totalLine: {
    borderTopWidth: 1,
    borderColor: '#bdbdbd',
    marginTop: 4,
    paddingTop: 6
  },
  lineLabel: { fontSize: 9, color: '#555555' },
  totalLabel: { fontSize: 10, color: '#000000', fontWeight: 'bold' },
  amountCell: { flexDirection: 'row', alignItems: 'center' },
  // Fixed widths keep the signs in one column and right-align the amounts against it; the sign hugs its number.
  amount: { width: 150, textAlign: 'right' },
  sign: { width: 10, paddingLeft: 2, textAlign: 'left' },
  lineAmount: { fontSize: 9, color: '#000000' },
  discountAmount: { fontSize: 9, color: '#2e7d32' },
  penaltyAmount: { fontSize: 9, color: '#c62828' },
  totalAmount: { fontSize: 10, color: '#000000', fontWeight: 'bold' },
  subtitle: {
    fontSize: 10,
    color: 'black'
  }
})

export default styles
